import Vue from 'vue';
import Vuex from 'vuex';
import auth from "@/auth/authService";
import config from '../../config/config.json';

Vue.use(Vuex);

const BASE_URI = process.env.NODE_ENV == 'production' ? window.location.protocol + '//' + window.location.hostname : config.url;

const {Device} = require('../pb/device_pb.js');
const {Template} = require('../pb/template_pb.js');
const {Image, ImageCredentials} = require('../pb/image_pb.js');
const {Plant, PlantInfo} = require('../pb/plant_pb.js');
const {AgentState} = require('../pb/agent_state_pb.js');
const {User} = require('../pb/user_pb.js');
const {KraftyServiceClient} = require('../pb/krafty_service_grpc_web_pb.js');

const grpc = {};
grpc.web = require('grpc-web');

var ksClient = new KraftyServiceClient(BASE_URI + '/_krafty', null, null);

Vue.use(Vuex);

const store = new Vuex.Store({
  data () {
    return {
      imageStream: {}
    }
  },
  state: {
    history: {},
    devices: {},
    templates: {},
    plants: {},
    images: {},
    imagecreds: {},
    upstream: {},
    user: {},
    isLoading: {
      history: false,
      devices: false,
      templates: false,
      plants: false,
      images: false,
      imagecreds: false,
      upstream: false
    },
    error: {
      value: false,
      stream: false,
      code: null,
      message: ''
    }
  },
  mutations: {
    resetHistory(state, data) {
      state.history = data;
      state.isLoading.history = false;
    },
    resetDevices(state, data) {
      state.devices = data;
      state.isLoading.devices = false;
    },
    updateDevices(state, device) {
      if (device.deleted) {
        Vue.delete(state.devices, device.deviceid);
      } else {
        Vue.set(state.devices, device.deviceid, device);
      }
    },
    resetTemplates(state, data) {
      state.templates = data;
      state.isLoading.templates = false;
    },
    updateTemplates(state, template) {
      if (template.deleted) {
        Vue.delete(state.templates, template.templateid);
      } else {
        Vue.set(state.templates, template.templateid, template);
      }
    },
    resetPlants(state, data) {
      state.plants = data;
      state.isLoading.plants = false;
    },
    resetImages(state, data) {
      state.images = data;
      state.isLoading.images = false;
    },
    updateImages(state, image) {
      if (image.deleted) {
        Vue.delete(state.images, image.imageid);
      } else {
        Vue.set(state.images, image.imageid, image);
      }
    },
    resetImageCreds(state, data) {
      state.imagecreds = data;
      state.isLoading.imagecreds = false;
    },
    resetUpstream(state, data) {
      state.upstream = data;
      state.isLoading.upstream = false;
    },
    resetUser(state, data) {
      state.user = data;
    },
    isLoading(state, component) {
      switch (component) {
        case "history":
          state.isLoading.history = true;
          break;
        case "devices":
          state.isLoading.devices = true;
          break;
        case "templates":
          state.isLoading.templates = true;
          break;
        case "plants":
          state.isLoading.plants = true;
          break;
        case "images":
            state.isLoading.images = true;
            break;
        case "imagecreds":
          state.isLoading.imagecreds = true;
          break;
        case "upstream":
          state.isLoading.upstream = true;
          break;
      }
    },
    updateError(state, err) {
      state.error.value = true;
      if (err.stream) {
        state.error.stream = true;
      } else {
        state.error.stream = false;
      }
      state.error.code = err.err.code;
      if (err.err.message) {
        state.error.message = err.err.message;
      } else if (err.err.details) {
        state.error.message = err.err.details;
      }
      state.isLoading.history = false;
      state.isLoading.devices = false;
      state.isLoading.templates = false;
      state.isLoading.plants = false;
      state.isLoading.images = false;
      state.isLoading.imagecreds = false;
      state.isLoading.upstream = false;
    },
    clearError(state) {
      state.error.value = false;
      state.error.stream = false;
      state.error.code = null;
      state.error.message = '';
    }
  },
  getters: {
    allHistory: (state) => {
      return state.history;
    },
    allDevices: (state) => {
      return state.devices;
    },
    allTemplates: (state) => {
      return state.templates;
    },
    allPlants: (state) => {
      return state.plants;
    },
    allImages: (state) => {
      return state.images;
    },
    allImageCreds: (state) => {
      return state.imagecreds;
    },
    allUpstream: (state) => {
      return state.upstream;
    },
    user: (state) => {
      return state.user;
    },
    isLoading: (state) => {
      return state.isLoading;
    },
    error: (state) => {
      return state.error;
    }
  },
  actions: {
    filterTemplates ({commit}) {
      commit('isLoading', 'templates');
      auth.getAccessToken().then(accessToken => {
        var metadata = {'Authorization': 'Bearer ' + accessToken};
        var request = new Template();
        var stream = ksClient.filterTemplates(request, metadata);
        var templates = {};
        stream.on('data', function(response) {
          var o = response.toObject();
          templates[o.templateid] = o;
        });
        stream.on('end', function() {
          commit('resetTemplates', templates);
        });
        stream.on('error', (err) => {
          commit('updateError', {err: err, func: 'filterTemplates'});
        });
      });
    },
    newTemplate({commit}, args) {
      return new Promise(function(resolve, reject) {
        var request = new Template();
        request.setOwner(auth.profile.email);
        request.setOs(args.os);
        request.setType(args.type);
        auth.getAccessToken().then(accessToken => {
          var deadline = new Date();
          deadline.setSeconds(deadline.getSeconds() + 300);
          var metadata = {'Authorization': 'Bearer ' + accessToken, deadline: deadline.getTime()};
          ksClient.newTemplate(request, metadata, (err, response) => {
            if (err) {
              reject(err);
            } else {
              commit('updateTemplates', response.toObject());
              resolve(response.toObject());
            }
          });
        });
      });
    },
    updateTemplate({commit}, args) {
      return new Promise(function(resolve, reject) {
        if (!args) {
          reject("updateTemplate: empty call")
          return
        }
        var request = new Template();
        request.setTemplateid(args.templateid);
        request.setType(args.type);
        request.setOs(args.os);
        request.setDescription(args.description);
        request.setBaseimage(args.baseimage);
        request.setSourceimage(args.sourceimage);
        request.setInstallimage(args.installimage);
        request.setKickstart(args.kickstart);
        request.setBuildscript(args.buildscript);
        request.setPostinstall(args.postinstall);
        request.setPackagesList(args.packagesList);
        request.setOndemandpackagesList(args.ondemandpackagesList);
        request.setOptionalsvnfilesList(args.optionalsvnfilesList);
        request.setOwner(args.owner);
        auth.getAccessToken().then(accessToken => {
          var deadline = new Date();
          deadline.setSeconds(deadline.getSeconds() + 300);
          var metadata = {'Authorization': 'Bearer ' + accessToken, deadline: deadline.getTime()};
          ksClient.updateTemplate(request, metadata, (err, response) => {
            if (err) {
              commit('updateError', {err: err, func: 'updateTemplate'});
              reject(err);
            } else {
              commit('updateTemplates', response.toObject());
              resolve(response.toObject());
            }
          });
        });
      });
    },
    deleteTemplate({commit}, args) {
      return new Promise(function(resolve, reject) {
        if (!args) {
          reject("deleteTemplate: empty call")
          return
        }
        var request = new Template();
        request.setTemplateid(args.templateid);
        request.setOwner(args.owner);
        auth.getAccessToken().then(accessToken => {
          var deadline = new Date();
          deadline.setSeconds(deadline.getSeconds() + 300);
          var metadata = {'Authorization': 'Bearer ' + accessToken, deadline: deadline.getTime()};
          ksClient.deleteTemplate(request, metadata, (err, response) => {
            if (err) {
              commit('updateError', {err: err, func: 'deleteTemplate'});
              reject(err);
            } else {
              commit('updateTemplates', response.toObject());
              resolve(response.toObject());
            }
          });
        });
      });
    },
    approveTemplate({commit, dispatch}, args) {
      return new Promise(function(resolve, reject) {
        if (!args) {
          reject("approveTemplate: empty call")
          return
        }
        var request = new Template();
        request.setTemplateid(args.templateid);
        request.setApproved(args.approved);
        request.setOwner(args.owner);
        auth.getAccessToken().then(accessToken => {
          var deadline = new Date();
          deadline.setSeconds(deadline.getSeconds() + 300);
          var metadata = {'Authorization': 'Bearer ' + accessToken, deadline: deadline.getTime()};
          ksClient.approveTemplate(request, metadata, (err, response) => {
            if (err) {
              dispatch('filterTemplates');
              reject(err);
            } else {
              commit('updateTemplates', response.toObject());
              resolve(response.toObject());
            }
          });
        });
      });
    },
    filterDevices({commit}) {
      commit('isLoading', 'devices');
      auth.getAccessToken().then(accessToken => {
        var metadata = {'Authorization': 'Bearer ' + accessToken};
        var request = new Device();
        var stream = ksClient.filterDevices(request, metadata);
        var devices = {};
        stream.on('data', function(response) {
          var o = response.toObject();
          devices[o.deviceid] = o;
        });
        stream.on('end', function() {
          commit('resetDevices', devices);
        });
        stream.on('error', (err) => {
          commit('updateError', {err: err, func: 'filterDevices'});
        });
      });
    },
    newDevice({commit}) {
      return new Promise(function(resolve, reject) {
        var request = new Device();
        request.setOwner(auth.profile.email);
        auth.getAccessToken().then(accessToken => {
          var deadline = new Date();
          deadline.setSeconds(deadline.getSeconds() + 300);
          var metadata = {'Authorization': 'Bearer ' + accessToken, deadline: deadline.getTime()};
          ksClient.newDevice(request, metadata, (err, response) => {
            if (err) {
              commit('updateError', {err: err, func: 'newDevice'});
              reject(err);
            } else {
              commit('updateDevices', response.toObject());
              resolve(response.toObject());
            }
          });
        });
      });
    },
    updateDevice({commit}, args) {
      return new Promise(function(resolve, reject) {
        if (!args) {
          reject("updateDevice: empty call")
          return
        }
        var request = new Device();
        request.setDeviceid(args.deviceid);
        request.setType(args.type);
        request.setModel(args.model);
        request.setDescription(args.description);
        request.setTemplateid(args.templateid);
        request.setPostinstall(args.postinstall);
        request.setPackagesList(args.packagesList);
        request.setOwner(args.owner);
        auth.getAccessToken().then(accessToken => {
          var deadline = new Date();
          deadline.setSeconds(deadline.getSeconds() + 300);
          var metadata = {'Authorization': 'Bearer ' + accessToken, deadline: deadline.getTime()};
          ksClient.updateDevice(request, metadata, (err, response) => {
            if (err) {
              commit('updateError', {err: err, func: 'updateDevice'});
              reject(err);
            } else {
              commit('updateDevices', response.toObject());
              resolve(response.toObject());
            }
          });
        });
      });
    },
    deleteDevice({commit}, args) {
      return new Promise(function(resolve, reject) {
        if (!args) {
          reject("deleteDevice: empty call")
          return
        }
        var request = new Device();
        request.setOwner(args.owner);
        request.setDeviceid(args.deviceid);
        auth.getAccessToken().then(accessToken => {
          var deadline = new Date();
          deadline.setSeconds(deadline.getSeconds() + 300);
          var metadata = {'Authorization': 'Bearer ' + accessToken, deadline: deadline.getTime()};
          ksClient.deleteDevice(request, metadata, (err, response) => {
            if (err) {
              commit('updateError', {err: err, func: 'deleteDevice'});
              reject(err);
            } else {
              commit('updateDevices', response.toObject());
              resolve(response.toObject());
            }
          });
        });
      });
    },
    approveDevice({commit, dispatch}, args) {
      return new Promise(function(resolve, reject) {
        if (!args) {
          reject("approveDevice: empty call")
          return
        }
        var request = new Device();
        request.setDeviceid(args.deviceid);
        request.setApproved(args.approved);
        request.setOwner(args.owner);
        auth.getAccessToken().then(accessToken => {
          var deadline = new Date();
          deadline.setSeconds(deadline.getSeconds() + 300);
          var metadata = {'Authorization': 'Bearer ' + accessToken, deadline: deadline.getTime()};
          ksClient.approveDevice(request, metadata, (err, response) => {
            if (err) {
              dispatch('filterDevices');
              reject(err);
            } else {
              commit('updateDevices', response.toObject());
              resolve(response.toObject());
            }
          });
        });
      });
    },
    filterPlants({commit}) {
      commit('isLoading', 'plants');
      auth.getAccessToken().then(accessToken => {
        var metadata = {'Authorization': 'Bearer ' + accessToken};
        var request = new Plant();
        var stream = ksClient.filterPlants(request, metadata);
        var plants = {};
        stream.on('data', function(response) {
          var o = response.toObject();
          plants[o.plantfolder] = o;
        });
        stream.on('end', function() {
          commit('resetPlants', plants);
        });
        stream.on('error', (err) => {
          commit('updateError', {err: err, func: 'filterPlants'});
        });
      });
    },
    refreshPlants({commit}) {
      commit('isLoading', 'plants');
      return new Promise(function(resolve, reject) {
        auth.getAccessToken().then(accessToken => {
          var metadata = {'Authorization': 'Bearer ' + accessToken};
          var request = new Plant();
          var stream = ksClient.refreshPlants(request, metadata);
          var plants = {};
          stream.on('data', function(response) {
            var o = response.toObject();
            plants[o.plantfolder] = o;
          });
          stream.on('end', function() {
            resolve();
            commit('resetPlants', plants);
          });
          stream.on('error', (err) => {
            reject(err);
            commit('updateError', {err: err, func: 'refreshPlants'});
          });
        });
      });
    },
    getPlantInfo({commit}, args) {
      return new Promise(function(resolve, reject) {
        if (!args) {
          reject("getPlantInfo: empty call")
          return
        }
        var request = new PlantInfo();
        request.setCtrl0id(args.ctrl0id);
        request.setPlantfolder(args.plantfolder);
        auth.getAccessToken().then(accessToken => {
          var deadline = new Date();
          deadline.setSeconds(deadline.getSeconds() + 300);
          var metadata = {'Authorization': 'Bearer ' + accessToken, deadline: deadline.getTime()};
          ksClient.getPlantInfo(request, metadata, (err, response) => {
            if (err) {
              commit('updateError', {err: err, func: 'getPlantInfo'});
              reject(err);
            } else {
              resolve(response.toObject());
            }
          });
        });
      });
    },
    filterUpstream({commit}) {
      commit('isLoading', 'upstream');
      auth.getAccessToken().then(accessToken => {
        var metadata = {'Authorization': 'Bearer ' + accessToken};
        var request = new Template();
        var stream = ksClient.filterUpstream(request, metadata);
        var upstream = {};
        stream.on('data', function(response) {
          var o = response.toObject();
          upstream[o.name] = o;
        });
        stream.on('end', function() {
          commit('resetUpstream', upstream);
        });
        stream.on('error', (err) => {
          commit('updateError', {err: err, func: 'filterUpstream'});
        });
      });
    },
    // eslint-disable-next-line no-empty-pattern
    getAgentState({}, args) {
      return new Promise(function(resolve, reject) {
        if (!args) {
          reject("getAgentState: empty call")
          return
        }
        var request = new AgentState();
        request.setAgentid(args.agentid);
        auth.getAccessToken().then(accessToken => {
          var deadline = new Date();
          deadline.setSeconds(deadline.getSeconds() + 300);
          var metadata = {'Authorization': 'Bearer ' + accessToken, deadline: deadline.getTime()};
          ksClient.getAgentState(request, metadata, (err, response) => {
            if (err) {
              // commit('updateError', {err: err, func: 'getAgentState'});
              reject(err);
            } else {
              resolve(response.toObject());
            }
          });
        });
      });
    },
    newImage({commit}, args) {
      return new Promise(function(resolve, reject) {
        if (!args) {
          reject("newImage: empty call")
          return
        }
        var request = new Image();
        request.setType(args.type);
        request.setPlantfolder(args.plantfolder);
        request.setPlantid(args.plantid);
        request.setSiteid(args.siteid);
        request.setTemplateid(args.templateid);
        request.setRemotemanagement(args.remotemanagement);
        request.setRemoteaccess(args.remoteaccess);
        request.setRemoteaccessport(args.remoteaccessport);
        //request.getWorkerOptions().set(args.workerOptions);
        console.log(request)
        //request.getWorkeroptionsMap().set("optWantUpdates",args.workerOptions.optWantUpdates);
        //request.getWorkeroptionsMap().set("optWantUpdates","1");
        request.setPackageversionsList(args.packageversionsList);
        request.setOwner(auth.profile.email);
        auth.getAccessToken().then(accessToken => {
          var deadline = new Date();
          deadline.setSeconds(deadline.getSeconds() + 300);
          var metadata = {'Authorization': 'Bearer ' + accessToken, deadline: deadline.getTime()};
          ksClient.newImage(request, metadata, (err, response) => {
            if (err) {
              commit('updateError', {err: err, func: 'newImage'});
              reject(err);
            } else {
              resolve(response.toObject());
            }
          });
        });
      });
    },
    filterImages({commit}) {
      commit('isLoading', 'images');
      auth.getAccessToken().then(accessToken => {
        var metadata = {'Authorization': 'Bearer ' + accessToken};
        var request = new Image();
        var stream = ksClient.filterImages(request, metadata);
        var images = {};
        
        stream.on('data', function(response) {
          var o = response.toObject();
          images[o.imageid] = o;
        });
        stream.on('end', function() {
          commit('resetImages', images);
        });
        stream.on('error', (err) => {
          console.error(err)
          commit('updateError', {err: err, func: 'filterImages'});
        });
      });
    },
    watchImages({commit, dispatch}, retry) {
      if (!retry) retry = 0;
      if (this.imageStream) this.imageStream.cancel();
      auth.getAccessToken().then(accessToken => {
        var metadata = {'Authorization': 'Bearer ' + accessToken};
        var request = new Image();
        this.imageStream = ksClient.watchImages(request, metadata);
        this.imageStream.on('data', function(response) {
          retry = 0;
          commit('updateImages', response.toObject());
        });
        this.imageStream.on('end', function() {
        });
        this.imageStream.on('error', (err) => {
          if (retry < 5) {
            new Promise(resolve => setTimeout(resolve, 2000 * retry * retry)).then(() => {
              dispatch('watchImages', retry+1);
            });
          } else {
            commit('updateError', {err: err, func: 'watchImages', stream: true});
          }
        });
      });
    },
    deleteImage({commit}, args) {
      return new Promise(function(resolve, reject) {
        if (!args) {
          reject("deleteImage: empty call")
          return
        }
        var request = new Image();
        request.setImageid(args.imageid);
        request.setOwner(args.owner);
        auth.getAccessToken().then(accessToken => {
          var deadline = new Date();
          deadline.setSeconds(deadline.getSeconds() + 300);
          var metadata = {'Authorization': 'Bearer ' + accessToken, deadline: deadline.getTime()};
          ksClient.deleteImage(request, metadata, (err, response) => {
            if (err) {
              commit('updateError', {err: err, func: 'deleteImage'});
              reject(err);
            } else {
              resolve(response.toObject());
            }
          });
        });
      });
    },
    verifyImage({commit}, args) {
      return new Promise(function(resolve, reject) {
        if (!args) {
          reject("verifyImage: empty call")
          return
        }
        var request = new Image();
        request.setImageid(args.imageid);
        request.setOwner(args.owner);
        auth.getAccessToken().then(accessToken => {
          var deadline = new Date();
          deadline.setSeconds(deadline.getSeconds() + 300);
          var metadata = {'Authorization': 'Bearer ' + accessToken, deadline: deadline.getTime()};
          ksClient.verifyImage(request, metadata, (err, response) => {
            if (err) {
              commit('updateError', {err: err, func: 'verifyImage'});
              reject(err);
            } else {
              resolve(response.toObject());
            }
          });
        });
      });
    },
    filterCredentials({commit}) {
      commit('isLoading', 'imagecreds');
      auth.getAccessToken().then(accessToken => {
        var metadata = {'Authorization': 'Bearer ' + accessToken};
        var request = new ImageCredentials();
        var stream = ksClient.filterCredentials(request, metadata);
        var imagecreds = {};
        stream.on('data', function(response) {
          var o = response.toObject();
          imagecreds[o.imageid] = o;
        });
        stream.on('end', function() {
          commit('resetImageCreds', imagecreds);
        });
        stream.on('error', (err) => {
          commit('updateError', {err: err, func: 'filterCredentials'});
        });
      });
    },
    // eslint-disable-next-line no-empty-pattern
    getCredentials({}, args) {
      return new Promise(function(resolve, reject) {
        if (!args) {
          reject("getCredentials: empty call")
          return
        }
        var request = new ImageCredentials();
        request.setImageid(args.imageid);
        auth.getAccessToken().then(accessToken => {
          var deadline = new Date();
          deadline.setSeconds(deadline.getSeconds() + 300);
          var metadata = {'Authorization': 'Bearer ' + accessToken, deadline: deadline.getTime()};
          ksClient.getCredentials(request, metadata, (err, response) => {
            if (err) {
              reject(err);
            } else {
              resolve(response.toObject());
            }
          });
        });
      });
    },
    deleteCredentials({commit}, args) {
      return new Promise(function(resolve, reject) {
        if (!args) {
          reject("deleteCredentials: empty call")
          return
        }
        var request = new ImageCredentials();
        request.setImageid(args.imageid);
        request.setOwner(args.owner);
        auth.getAccessToken().then(accessToken => {
          var deadline = new Date();
          deadline.setSeconds(deadline.getSeconds() + 300);
          var metadata = {'Authorization': 'Bearer ' + accessToken, deadline: deadline.getTime()};
          ksClient.deleteCredentials(request, metadata, (err, response) => {
            if (err) {
              commit('updateError', {err: err, func: 'deleteCredentials'});
              reject(err);
            } else {
              resolve(response.toObject());
            }
          });
        });
      });
    },
    fromContext({commit}) {
      return new Promise(function(resolve, reject) {
        var request = new User();
        request.setEmail(auth.profile.email);
        auth.getAccessToken().then(accessToken => {
          var deadline = new Date();
          deadline.setSeconds(deadline.getSeconds() + 300);
          var metadata = {'Authorization': 'Bearer ' + accessToken, deadline: deadline.getTime()};
          ksClient.fromContext(request, metadata, (err, response) => {
            if (err) {
              commit('updateError', {err: err, func: 'fromContext'});
              reject(err);
            } else {
              commit('resetUser', response.toObject());
              resolve(response.toObject());
            }
          });
        });
      });
    },
    clearError({commit}) {
      commit('clearError');
    }
  }
});

export default store;
